import { onError } from '@apollo/client/link/error';

import { SENTRY_DSN, SENTRY_ENV } from '../constants';

import * as Sentry from '@sentry/react';

export const errorControl = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      Sentry.captureException(error);
    });
  }
  if (networkError) {
    Sentry.captureException(networkError);
  }
});

export const setupSentry = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
    integrations: [Sentry.replayIntegration()],
    tracesSampleRate: 1.0
  });
};
